import { Offcanvas } from "react-bootstrap";
import { getRemainingDays, getExpDate, formatAmount } from "../helper/utils";
import { PRODUCT_TYPES } from "../helper/constant";

const SharedOffcanvas = ({ show, title, handleClose, data, forSellingTab = false }) => {
    if (!data) return null;

    const product = data.productId;

    const productDetailsConfig = [
        {
            label: "Chipset",
            value: product?.chipset,
        },
        {
            label: "Brand",
            value: product?.brand,
        },
        {
            label: "Series",
            value: product?.series,
        },
        {
            label: "Model",
            value: product?.model,
        },
        {
            label: "Product Type",
            value: PRODUCT_TYPES[product?.type],
        },
    ];

    const bidPricingConfig = [
        {
            label: "Bid Amount:",
            key: "bidAmount",
        },
        {
            label: "Testing Fee:",
            key: "testingFee",
            condition: (product) => product?.type === 3,
        },
        {
            label: "Shipping Fee:",
            key: "shippingFee",
        },
        {
            label: "Processing Fee:",
            key: "processingFee",
        },
        {
            label: "Sales Tax:",
            key: "salesTax",
        }
    ];

     const askPricingConfig = [
        {
            label: "Ask Amount:",
            key: "askAmount",
        },
        {
            label: "Selling Fee:",
            key: "transactionFee"
        },
        {
            label: "Payout Fee:",
            key: "processingFee",
        }
        // {
        //     label: "Processing Fee:",
        //     key: "transactionFee",
        // },
        // {
        //     label: "Sales Tax:",
        //     key: "salesTax",
        // }
    ];


    return (
        <Offcanvas show={show} onHide={handleClose} placement="end">
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>
                    <h4>{title}</h4>
                </Offcanvas.Title>
            </Offcanvas.Header>

            <Offcanvas.Body>
                <div className="p-3">
                    {/* Product Information */}
                    <div >
                        <div style={{ cursor: "pointer" }} onClick={() => {
                            window.open(`/product/${product?.slug}`, "_blank");
                        }} className="text-center mb-3">
                            <img
                                src={
                                    product?.image?.[0]?.startsWith("http")
                                        ? product.image[0]
                                        : `${process.env.REACT_APP_IMAGEBASEURL}${product.image[0]}`
                                }
                                alt={product?.productname}
                                style={{
                                    width: "100%",
                                    maxWidth: "200px",
                                    borderRadius: "8px",
                                }}

                            />
                        </div>

                        <h5 style={{ cursor: "pointer" }} onClick={() => {
                            window.open(`/product/${product?.slug}`, "_blank");
                        }} className="text-center">{product?.productname}</h5>

                        <div style={{ cursor: "pointer" }} onClick={() =>
                            window.open(`/bidask/${product?.slug}`, "_blank")
                        } className="text-center mb-3">
                            {
                                forSellingTab ? (
                                    <div>
                                        {
                                            product?.highest_bid && product?.highest_bid > 0 ? (
                                                <button

                                                    className="btn btn-success px-3 py-2 border border-dark"
                                                    style={{ backgroundColor: "#990000", borderRadius: "50px", fontSize: "14px" }}
                                                >
                                                    Sell Now – {product?.highest_bid > 0 ? `$${product.highest_bid}` : "N/A"}
                                                </button>
                                            ) : (
                                                <span className="fw-bold text-danger">
                                                    Sell Now –{" "}
                                                    {product?.highest_bid > 0 ? `$${product.highest_bid}` : "N/A"}
                                                </span>
                                            )
                                        }
                                    </div>
                                ) : (
                                    <div>
                                        {
                                            product?.lowest_ask && product?.lowest_ask > 0 ? (
                                                <button

                                                    className="btn btn-success px-3 py-2 border border-dark"
                                                    style={{ backgroundColor: "#225e40", borderRadius: "50px", fontSize: "14px" }}
                                                >
                                                    Buy Now – {product?.lowest_ask > 0 ? `$${product.lowest_ask}` : "N/A"}
                                                </button>
                                            ) : (
                                                <span className="fw-bold text-success">
                                                    Buy Now –{" "}
                                                    {product?.lowest_ask > 0 ? `$${product.lowest_ask}` : "N/A"}
                                                </span>
                                            )
                                        }
                                    </div>
                                )
                            }

                        </div>
                    </div>

                    {
                        forSellingTab ? (
                              <div className="p-2 border rounded mb-3">
                                <h5 className="mb-2 pb-2 border-bottom fw-bold">Ask Details</h5>
                                {/* Pricing */}
                                <h6 className="text-muted mb-2">Ask Pricing</h6>

                                {askPricingConfig.map(({ label, key, condition }) => {
                                    if (condition && !condition(product)) return null;

                                    return (
                                        <div className="row mb-2" key={key}>
                                            <div className="col-8">
                                                <strong>{label}</strong>
                                            </div>
                                            <div className="col-4 text-end">
                                                {formatAmount(data[key])}
                                            </div>
                                        </div>
                                    );
                                })}

                                <div className="row mb-3">
                                    <div className="col-8">
                                        <strong>Total</strong>
                                    </div>
                                    <div className="col-4 text-end fw-bold">
                                        {formatAmount(data.subTotal)}
                                    </div>
                                </div>
                                <hr />


                                {/* Validity */}
                                <h6 className="text-muted mb-2">Ask Validity</h6>

                                <div className="row mb-2">
                                    <div className="col-8">
                                        <strong>Expiration Date</strong>
                                    </div>
                                    <div className="col-4 text-end">
                                        {getExpDate(data.createdAt, data.expirationTime)}
                                    </div>
                                </div>

                                <div className="row mb-2">
                                    <div className="col-8">
                                        <strong>Remaining Days</strong>
                                    </div>
                                    <div className="col-4 text-end">
                                        {getRemainingDays(data.createdAt, data.expirationTime)}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-8">
                                        <strong>Status</strong>
                                    </div>
                                    <div className="col-4 text-end">
                                        {getRemainingDays(data.createdAt, data.expirationTime) <= 0 ? (
                                            <span className="text-danger">Expired</span>
                                        ) : (
                                            <span className="text-success">Active</span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="p-2 border rounded mb-3">
                                <h5 className="mb-2 pb-2 border-bottom fw-bold">Bid Details</h5>
                                {/* Pricing */}
                                <h6 className="text-muted mb-2">Bid Pricing</h6>

                                {bidPricingConfig.map(({ label, key, condition }) => {
                                    if (condition && !condition(product)) return null;

                                    return (
                                        <div className="row mb-2" key={key}>
                                            <div className="col-8">
                                                <strong>{label}</strong>
                                            </div>
                                            <div className="col-4 text-end">
                                                {formatAmount(data[key])}
                                            </div>
                                        </div>
                                    );
                                })}

                                <div className="row mb-3">
                                    <div className="col-8">
                                        <strong>Total</strong>
                                    </div>
                                    <div className="col-4 text-end fw-bold">
                                        {formatAmount(data.subTotal)}
                                    </div>
                                </div>
                                <hr />


                                {/* Validity */}
                                <h6 className="text-muted mb-2">Bid Validity</h6>

                                <div className="row mb-2">
                                    <div className="col-8">
                                        <strong>Expiration Date</strong>
                                    </div>
                                    <div className="col-4 text-end">
                                        {getExpDate(data.createdAt, data.expirationTime)}
                                    </div>
                                </div>

                                <div className="row mb-2">
                                    <div className="col-8">
                                        <strong>Remaining Days</strong>
                                    </div>
                                    <div className="col-4 text-end">
                                        {getRemainingDays(data.createdAt, data.expirationTime)}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-8">
                                        <strong>Status</strong>
                                    </div>
                                    <div className="col-4 text-end">
                                        {getRemainingDays(data.createdAt, data.expirationTime) <= 0 ? (
                                            <span className="text-danger">Expired</span>
                                        ) : (
                                            <span className="text-success">Active</span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )
                    }



                    {/* product details */}
                    <div className="p-2 border rounded mb-2">
                        <h5 className="border-bottom mb-2 pb-2 fw-bold">Product Details</h5>

                        {productDetailsConfig.map(({ label, value, render }, index) => (
                            <div className="mb-2 d-flex flex-row gap-2" key={index}>
                                <div className="">
                                    <strong>{label}: </strong>
                                </div>

                                <div className="">
                                    {render ? render() : value ?? "N/A"}
                                </div>

                            </div>
                        ))}
                    </div>

                    <div className="p-2 border rounded mb-2">
                        <h5 className="border-bottom mb-2 pb-2 fw-bold">Product Description</h5>

                        <div>
                            <strong>Description:</strong>
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: product?.description,
                                }}
                            />
                        </div>
                    </div>


                </div>
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default SharedOffcanvas;
